import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as eFAACTCustomerActions from './efaact-customer.actions';
import { eFAACTCustomer } from './efaact-customer.model';

export const eFAACTCustomerFeatureKey = 'eFAACTCustomer';

export interface State extends EntityState<eFAACTCustomer> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> = createEntityAdapter<eFAACTCustomer>({
    selectId: (model: eFAACTCustomer) => `${model.custid}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const eFAACTCustomerReducer = createReducer(
    initialState,
    on(eFAACTCustomerActions.addeFAACTCustomer, (state, action) =>
        adapter.addOne(action.eFAACTCustomer, state)
    ),
    on(eFAACTCustomerActions.upserteFAACTCustomer, (state, action) =>
        adapter.upsertOne(action.eFAACTCustomer, state)
    ),
    on(eFAACTCustomerActions.addeFAACTCustomers, (state, action) =>
        adapter.addMany(action.eFAACTCustomers, state)
    ),
    on(eFAACTCustomerActions.upserteFAACTCustomers, (state, action) =>
        adapter.upsertMany(action.eFAACTCustomers, state)
    ),
    on(eFAACTCustomerActions.updateeFAACTCustomer, (state, action) =>
        adapter.updateOne(action.eFAACTCustomer, state)
    ),
    on(eFAACTCustomerActions.updateeFAACTCustomers, (state, action) =>
        adapter.updateMany(action.eFAACTCustomers, state)
    ),
    on(eFAACTCustomerActions.deleteeFAACTCustomer, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(eFAACTCustomerActions.deleteeFAACTCustomers, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(eFAACTCustomerActions.loadeFAACTCustomers, (state, action) =>
        adapter.setAll(action.eFAACTCustomers, state)
    ),
    on(eFAACTCustomerActions.cleareFAACTCustomers, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return eFAACTCustomerReducer(state, action);
}

export const selecteFAACTCustomerState = createFeatureSelector<State>(
    eFAACTCustomerFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selecteFAACTCustomerState);
